import type { EmbedContext } from "./types.js";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;

export function collectContext(platform: string): EmbedContext {
  return {
    platform,
    hostname: window.location.hostname,
    pageUrl: window.location.href,
    pageTitle: document.title,
    referrer: document.referrer,
    screenWidth: window.screen.width,
  };
}

export function collectPageParams(
  reservedMetadataKeys: readonly string[] = [],
): {
  utm: Record<string, string>;
  metadata: Record<string, string>;
} {
  const params = new URLSearchParams(window.location.search);
  const utm: Record<string, string> = {};
  const metadata: Record<string, string> = {};
  const reservedKeys = new Set(
    reservedMetadataKeys.map((key) => key.toLowerCase()),
  );

  params.forEach((value, key) => {
    const lower = key.toLowerCase();
    if ((UTM_KEYS as readonly string[]).includes(lower)) {
      const shortKey = lower.replace("utm_", "");
      utm[shortKey] = value;
    } else if (!reservedKeys.has(lower)) {
      metadata[key] = value;
    }
  });

  return { utm, metadata };
}
